import request from "@/utils/request.js";

export const getHotelReviewsNote = (params) => {
    return request.get("/hotel/note",params);
};
export const getHotelReviewsNoteCount = (params) => {
    return request.get("/hotel/note/count",params);
};
export const getRestaurantReviewsNoteCount = (params) => {
    return request.get("/restaurant/note/count",params);
};
export const hotelReviewsNote = (data) => {
    return request.post("/hotel/note",data);
};

export const delHotelReviewsNote = (data) => {
    return request.delete(`/hotel/note/${data.id}`);
};

// 单条评论的处理详情：当前 note / status / priority + logs（每次保存一条，含修改人、时间、remark）
export const getHotelReviewNoteDetail = (reviewId) => {
    return request.get(`/hotel/note/${reviewId}`);
};
export const getRestaurantReviewNoteDetail = (reviewId) => {
    return request.get(`/restaurant/note/${reviewId}`);
};

export const getRestaurantReviewsNote = (params) => {
    return request.get("/restaurant/note", params);
};
export const restaurantReviewsNote = (data) => {
    return request.post("/restaurant/note", data);
};

export const delRestaurantReviewsNote = (data) => {
    return request.delete(`/restaurant/note/${data.id}`);
};
